import { computed } from 'vue';
import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';
import { useAdminStore } from '@app/stores';
import { useToast } from 'vue-toastification';

export const useReferrals = () => {
  const adminStore = useAdminStore();
  const toast = useToast();

  const personalLink = computed(() => {
    const businessId = adminStore.businessSiteData.bid;
    return `${import.meta.env.VITE_BUSINESS_WEBSITE_DOMAIN}/join?ref=${businessId}`;
  });

  const copyReferralLink = async () => {
    console.log('copy');
    if (Capacitor.isNativePlatform()) {
      await Clipboard.write({
        string: personalLink.value
      });
    } else {
      await navigator.clipboard.writeText(personalLink.value);
    }
    toast.success('הקישור הועתק בהצלחה 😃');

  };

  return {
    personalLink,
    copyReferralLink
  }
}
